<template>
  <v-app :style="appStyle">
    <AppBar @toggle="toggleAppDrawer(!isDrawerOpen)" />
    <AppDrawer
      :isOpen="isDrawerOpen"
      @toggle="toggleAppDrawer"
    />

    <v-main>
      <component :is="contentDrawer"></component>
      <CoreView />
    </v-main>

    <SnackBar />
    <AppDialog />
  </v-app>
</template>

<script>
import { getTheme, getAssets } from "@/plugins/vuetify"

export default {
  components: {
    AppBar: () => import("@/components/layouts/core/AppBar.vue"),
    AppDialog: () => import("@/components/utils/GlobalDialog.vue"),
    AppDrawer: () => import("@/components/layouts/core/AppDrawer.vue"),
    CoreView: () => import("@/components/layouts/core/View.vue"),
    SnackBar: () => import("@/components/utils/ErrorHandler.vue")
  },
  data() {
    return {
      isDrawerOpen: false
    }
  },
  computed: {
    appStyle() {
      let theme = getTheme(this)
      let assets = getAssets(this, "common")

      return {
        backgroundAttachement: "fixed",
        backgroundColor: theme.background,
        backgroundImage: `url(${assets.background})`,
        backgroundPosition: "bottom right",
        backgroundRepeat: "no-repeat"
      }
    },
    contentDrawer() {
      return this.$route.meta?.drawer
    }
  },
  methods: {
    onClick() {
      this.$store.commit("drawer/setMainDrawer", !this.$store.state.drawer.main)
    },
    toggleAppDrawer(newValue) {
      this.isDrawerOpen = newValue
    }
  }
}
</script>
